import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-cash-amount-dialog',
    templateUrl: './cash-amount-dialog.component.html',
    styleUrls: ['./cash-amount-dialog.component.css']
})
export class CashAmountDialogComponent {
    amount: number | null = null;
    isValid: boolean = false;

    constructor(public dialogRef: MatDialogRef<CashAmountDialogComponent>) { }

    onCancel(): void {
        this.dialogRef.close(null);
    }

    onConfirm(): void {
        if (this.isValid && this.amount !== null) {
            this.dialogRef.close(this.amount);
        }
    }

    validateAmount() {
        this.isValid = this.amount !== null && this.amount >= 0;
    }

    onKeydown(event: KeyboardEvent) {
        if (event.key === 'Enter' && this.isValid) {
            this.onConfirm();
        }
    }
}
